/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the best F1 Fantasy team?`)
};

const es_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es el mejor equipo de F1 Fantasy?`)
};

const de_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist das beste F1-Fantasy-Team?`)
};

const nl_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het beste F1 Fantasy-team?`)
};

const fr_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la meilleure équipe F1 Fantasy ?`)
};

const it_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la migliore squadra F1 Fantasy?`)
};

const pt_br2_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a melhor equipe de F1 Fantasy?`)
};

const pt_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a melhor equipa de F1 Fantasy?`)
};

const ja_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最強のF1ファンタジーチームとは？`)
};

const zh_f1_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最佳的 F1 Fantasy 车队是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_faq4_q", locale)
	if (locale === "en") return en_f1_faq4_q(inputs)
	if (locale === "es") return es_f1_faq4_q(inputs)
	if (locale === "de") return de_f1_faq4_q(inputs)
	if (locale === "nl") return nl_f1_faq4_q(inputs)
	if (locale === "fr") return fr_f1_faq4_q(inputs)
	if (locale === "it") return it_f1_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_faq4_q(inputs)
	if (locale === "pt") return pt_f1_faq4_q(inputs)
	if (locale === "ja") return ja_f1_faq4_q(inputs)
	return zh_f1_faq4_q(inputs)
};